import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(
      map(isAuthenticated => {
        const isEmailConfirmationRoute = state.url.startsWith('/email-confirmation');

        if (!isAuthenticated) {
          this.authService.setRedirectAfterLogin(state.url);
          if(isEmailConfirmationRoute) {
            this.authService.initiateLogin();
            return false;
          }
          this.router.navigate(['/']);
          return false;
        }

        const emailConfirmed = this.authService.getEmailConfirmedClaim();

        if (emailConfirmed === false) {
          if (isEmailConfirmationRoute) {
            return true;
          }
          this.router.navigate(['/email-confirmation-reminder']);
          return false;
        }

        return true;
      }),
      catchError(() => {
        this.authService.setRedirectAfterLogin(state.url);
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}
